var map = {
	"./0001-XZ-01.jpg": "PdLB",
	"./0002-A-01.jpg": "AeYp",
	"./0003-A-01.jpg": "/XTF",
	"./0004-A-01.jpg": "abfw",
	"./0005-A-01.jpg": "35tN",
	"./0006-A-01.jpg": "vCSq",
	"./0007-A-01.jpg": "9rlt",
	"./0008-A-01.jpg": "Xxex",
	"./0009-A-01.jpg": "f+hq",
	"./0010-A-01.jpg": "z63z",
	"./0011-A-01.jpg": "/VOb",
	"./0012-A-01.jpg": "mwRk",
	"./0013-A-01.jpg": "Ecou"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AudJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg \.*\.jpg|jpeg|png$
// module id = AudJ
// module chunks = 0